import NetworkMixin from "./network_mixin";
import ValidationMixin from "./validation_mixin";
import { Input, FormControls } from "../../elements";
import { eventBus, EVENTS } from "../../event_bus.js";
export default {
  name: 'LoginForm',
  components: {
    Input,
    FormControls
  },
  mixins: [NetworkMixin, ValidationMixin],

  data() {
    return {
      form: {
        login: "",
        password: "",
        token: ""
      },
      errorMessage: "",
      state: "DEFAULT"
    };
  },

  methods: {
    createUser() {
      if (!this.isFormValid()) {
        this.errorMessage = "form.login.error.FORM_INVALID";
      }

      if (this.errorMessage || this.state != "DEFAULT") {
        return;
      }

      this.state = "LOADING";
      this.networkLoginUser(this.form).then(response => {
        this.state = "DEFAULT";

        if (response.data.success) {
          eventBus.$emit(EVENTS.User.Login.Success);
          eventBus.$emit(EVENTS.User.Auth.Success);
        }
      }).catch(err => {
        this.state = "DEFAULT";

        if (err.status) {
          this.errorMessage = `form.login.error.${err.status}`;
        }

        eventBus.$emit(EVENTS.User.Login.Fail, err);
        eventBus.$emit(EVENTS.User.Auth.Fail, err);
      });
    },

    inputChanged() {
      if (this.errorMessage) {
        this.errorMessage = "";
      }
    }

  },

  created() {
    this.networkCreateRequestAuthToken().then(response => {
      this.form.token = response.data.content.token;
    });
  }

};